import { useCMSPageField } from '@/cms/fields'
import { buildImgSrc, ImageOrigin } from '@/helpers/image-url'
import DestinationSelector
  from '@/scopes/destinations/components/AllDestinations/DestinationSelector/DestinationSelector'
import styles from '@/scopes/destinations/components/Hero/Hero.module.css'
import { Image } from '@sunwebgroup/uds-ui/image'
import React from 'react'
import CommonHero, { MAX_HERO_IMAGE_WIDTH } from '../../Hero'

const HERO_IMAGE_HEIGHT = 319

function Hero() {
  const image = useCMSPageField('DestinationsPage.heroImage')
  const title = useCMSPageField('DestinationsPage.title')

  return (
    <CommonHero
      title={title}
      imageSlot={image && <HeroImage src={image} />}
      destinationSelectorSlot={<DestinationSelector />}
    />
  )
}
function HeroImage({ src }: { src: string }) {
  return (
    <Image
      src={buildImgSrc(src, MAX_HERO_IMAGE_WIDTH, HERO_IMAGE_HEIGHT, ImageOrigin.CMSSitecore, [401, 51])}
      className={styles.image}
      alt=""
    />
  )
}

export default Hero
